import React from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'

export default withRouter(({
    parentProject,
    match
}) => {
    if (!parentProject) {
        return null
    }

    const url = (() => {
        let pathname = match.path

        const accountSlug = pathname.split('/')[1]

        return `/${accountSlug}/projects/${parentProject.slug}`
    })()

    return (
        <div
            className={'task-project tooltip-trigger'}
        >
            <Link to={url}>
                <span>
                    {parentProject.name}
                </span>
                {parentProject.name.length > 17 ?
                    <div className="tooltip">
                        {parentProject.name}
                    </div>
                    : null}
            </Link>
        </div>
    )
})


// WEBPACK FOOTER //
// ./src/sections/projects/project/project-tasks/task/task-project.jsx